<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'MenuExpert'
});
</script>
<template>
  <ka-container
    code="menu-expert"
    :data="page.$info.menuExpert">
    <!-- Container 1 -->
    <ka-container code="container-1">
      <ka-icon
        code="icon"
        value="i-fa-solid:check-circle" />
      <ka-text
        code="pourquoi-matchers"
        :options="{
          href: { name: `hub-expert` },
          click: page.pourquoiMatchersClick
        }">
        <span v-html="t('menuExpert.container1.pourquoiMatchers.value', `Pourquoi Matchers ?`)" />
      </ka-text>
    </ka-container>
    <!-- Container 2 -->
    <ka-container code="container-2">
      <ka-icon
        code="icon-1"
        value="i-fa-solid:map" />
      <ka-text
        code="comment-ca-marche"
        :options="{
          href: { name: `hub-expert-Fonctionnement` },
          click: page.commentCaMarcheClick
        }">
        <span v-html="t('menuExpert.container2.commentCaMarche.value', `Comment ça marche ? `)" />
      </ka-text>
    </ka-container>
    <!-- Container 3 -->
    <ka-container code="container-3">
      <ka-icon
        code="icon-2"
        value="i-fa-solid:folder-open" />
      <ka-text
        code="ressources"
        :options="{
          href: { name: `hub-expert-Ressources` },
          click: page.ressourcesClick
        }">
        <span v-html="t('menuExpert.container3.ressources.value', `Ressources`)" />
      </ka-text>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncPageStore } from 'kapix-components-vue3'
import { menuExpertMenu } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p48')
const page = menuExpertMenu()

syncPageStore(page)
</script>
